export default __webpack_public_path__ + "static/media/Underdweller's Spear.c6fe68bc.jpg";